import api from '../config/api';
import axiosInstance from '../config/axios';
import { formatProjectDuplicateError } from '../utils/projectIdentityFields';

const enrichProjectError = (error) => {
  const formatted = formatProjectDuplicateError(error);
  const enriched = new Error(formatted);
  enriched.cause = error;
  enriched.response = error?.response;
  enriched.isDuplicateProject = error?.response?.data?.code === 'DUPLICATE_PROJECT';
  return enriched;
};

export const projectService = {
    // Create a new project
    async createProject(projectData) {
        try {
            const response = await axiosInstance.post(api.projects.create, projectData);
            return response.data;
        } catch (error) {
            console.error('Error creating project:', error);
            throw enrichProjectError(error);
        }
    },

    // Get all projects, optionally filtered by drug
    async listProjects(filter = {}) {
        try {
            let url = api.projects.list;
            if (filter.drug) {
                url += `?drug=${filter.drug}`;
            }
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            console.error('Error fetching projects:', error);
            throw error;
        }
    },

    // Check uniqueness for trialAcronym / sponsorProtocolIdentifier
    async checkUnique({ name, studyId, trialAcronym, sponsorProtocolIdentifier }) {
        try {
            const url = api.projects.checkUnique({
                name: trialAcronym ?? name,
                studyId: sponsorProtocolIdentifier ?? studyId,
            });
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            console.error('Error checking project uniqueness:', error);
            throw error;
        }
    },

    // Get a single project
    async getProject(id) {
        try {
            const response = await axiosInstance.get(api.projects.get(id));
            return response.data;
        } catch (error) {
            console.error('Error fetching project:', error);
            throw error;
        }
    },

    // Update a project
    async updateProject(id, projectData) {
        try {
            const response = await axiosInstance.put(api.projects.update(id), projectData);
            return response.data;
        } catch (error) {
            console.error('Error updating project:', error);
            throw enrichProjectError(error);
        }
    },

    // Delete a project
    async deleteProject(id) {
        try {
            const response = await axiosInstance.delete(api.projects.delete(id));
            return response.data;
        } catch (error) {
            console.error('Error deleting project:', error);
            throw error;
        }
    }
}; 